export function roleKey(user: { is_admin?: boolean } | null | undefined): string {
  if (user?.is_admin) return 'admin.sidebar.roles.admin';
  return 'admin.sidebar.roles.user';
}
